import { useMemo } from 'react';
import {
  getOrderDiscountState,
  isOrderDiscountEnabled,
  NO_ORDER_DISCOUNT,
} from './helpers';
import type { OrderDiscountStateT } from './types';

/**
 * Progress towards the next threshold discount for a given cart subtotal
 * (minor units). Recomputes on every cart change, so removing a line downgrades
 * or hides the badge immediately.
 *
 * `email` gates the internal-only rollout: shoppers outside it get a state that
 * renders nothing and leaves the cart total alone.
 */
export default function useOrderDiscounts(
  subtotal: number,
  email?: string | null,
): OrderDiscountStateT {
  const enabled = isOrderDiscountEnabled(email);

  return useMemo(
    () => (enabled ? getOrderDiscountState(subtotal) : NO_ORDER_DISCOUNT),
    [subtotal, enabled],
  );
}
